import { render, staticRenderFns } from "./IllnessStatsPage.vue?vue&type=template&id=12830dc6&scoped=true"
import script from "./IllnessStatsPage.vue?vue&type=script&lang=js"
export * from "./IllnessStatsPage.vue?vue&type=script&lang=js"
import style0 from "./IllnessStatsPage.vue?vue&type=style&index=0&id=12830dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12830dc6",
  null
  
)

export default component.exports